export default __webpack_public_path__ + "static/media/cp_geo_ao.dcf1e966.svg";